__webpack_require__.p = "/blogget/";